module.exports = __webpack_public_path__ + "img/wall-clock.7dcbb0da.svg";